const BASE_URL = 'https://www.planwise.social'

export interface BreadcrumbItem {
  name: string
  /** Site-relative path, e.g. '/blogs' or '/tools/post-preview'. Omit on the last (current-page) item. */
  path?: string
}

/**
 * Builds a schema.org BreadcrumbList — absent from every page before this,
 * despite most pages having a real 2-3 level hierarchy (Home > Blog >
 * [post], Home > Tools > [tool]). Helps both classic SERP breadcrumb rich
 * results and AI engines inferring page hierarchy/site structure.
 */
export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.path ? { item: `${BASE_URL}${item.path}` } : {}),
    })),
  }
}
